





























































































































































































































































































































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';

import MyForm from '@/mixins/form';
import _ from "lodash";
import DmarketingAdd from '@/views/dmarketing/add.vue';
import Settlement from './settlement.vue';
import VipSetting from './vip_setting.vue';
import moment from 'moment';
import MyConfig from "@/config.ts";

@Component({
  components: {
    Settlement,
    DmarketingAdd,
    VipSetting,
  },
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  @Prop() stadiumName!: string;

  @Prop() showBillModal!: (...args: any[]) => any;

  @Prop() showUserModal!: (...args: any[]) => any;

  @Prop() showVipModal!: (...args: any[]) => any;

  @Prop() showClubModal!: (...args: any[]) => any;

  loaddata = false;

  dmarketingType = 0;

  memberCostModal = false;

  dmarketingModalVisible = false;

  vipSettingModalVisible = false;

  memberCostForm!: any;
  uploadpercent = 0;
  apiserver: string = MyConfig.casapi;
  vipModal=false;

  headers: any = {
    Authorization: window.localStorage.getItem("token")
  };

  async loadSummaryBusiness() {
    this.spinLoading = true;
    const res = await this.$store.dispatch('datav/summaryBusiness', {
      stadium_id: this.stadiumId,
    });
    if (res && res.Data && res.Data !== '{}') {
      this.formData = res.Data;
    }
    this.spinLoading = false;
    this.loaddata = true;
  }

  showDmarketingModal(dmarketingType: number) {
    this.dmarketingType = dmarketingType;
    this.dmarketingModalVisible = true;
  }

  hideDmarketingModal() {
    this.dmarketingModalVisible = false;
  }

  showVipSettingModal() {
    this.vipSettingModalVisible = true;
  }

  hideVipSettingModal() {
    this.vipSettingModalVisible = false;
  }

  beforeCreate() {
    this.memberCostForm = this.$form.createForm(this);
  }

  mounted() {
    this.loadSummaryBusiness();
  }

  showMemberCostModal() {
    this.memberCostModal = true;
  }

  hideMemberCostModal() {
    this.memberCostModal = false;
  }

  handleMemberCost() {
    this.memberCostForm.validateFields((err: any, fieldsValue: any) => {
      if (!err) {
        // console.log(fieldsValue);
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            const fieldname = "member_cost";
            const res = await this.$store.dispatch("stadium/settingChange", {
              stadium_id: this.stadiumId,
              fieldname,
              fieldval: fieldsValue.money,
              content: "修改人力成本"
            });
            if (res && res.Message && res.Message === "success") {
              _.set(this.formData, [fieldname], this.tsMul(fieldsValue.money, 100));
              this.hideMemberCostModal();
              this.$message.success("操作成功");
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }

  async handleUpload(info: any) {
    if (info.file.status === "done") {
      this.handleVipModal(false)
      const res = info.file.response;
      if (parseInt(res.Code, 10) === 200) {
        this.$message.success(`操作成功`);
      } else {
        this.$message.error(res.Message);
      }
    } else {
      this.handleVipModal(true)
    }
  }

  handleVipModal(op:any){
    this.vipModal=op
  }

}
